import React from 'react';
import { func_cookieSetting, isDateValid, isNotNullUndefined, isNumberOrStringValid, isNumberValid, isStringTrimNotEmpty } from 'functions';
import moment from 'moment';
import { Tooltip } from 'components/informational/Tooltip';

export function useTableColumns() {

    function getColumn_category() {
        let columnClassName = "table__column-category";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Category",
            id: "category",
            accessor: "PERFORMED_CATEGORY",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 100
        }
    }

    function getColumn_systemRemark() {
        let columnClassName = "table__column-system-remark";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "System Remark",
            id: "systemRemark",
            accessor: "PERFORMED_SYSTEM_REMARK",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <Tooltip
                        targetClassName={"column-system-remark__content noWrap-text-ellipsis"}
                        target={value_formatted}
                        tooltipContent={value_formatted}
                    />
                );
            },
            width: 400
        }
    }

    function getColumn_userEmail() {
        let columnClassName = "table__column-user-email";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "User Email",
            id: "performedBy",
            accessor: "PERFORMED_BY",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <Tooltip
                        targetClassName={"column-user-email__content noWrap-text-ellipsis"}
                        target={value_formatted}
                        tooltipContent={value_formatted}
                    />
                );
            },
            width: 250
        }
    }

    function getColumn_date() {
        let columnClassName = "table__column-date";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Date",
            id: "date",
            accessor: "PERFORMED_DATE",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = "-";
                if (isStringTrimNotEmpty(value)) value_formatted = value;
                // if (isDateValid(value)) 
                //     value_formatted = moment(value).format("DD/MM/YYYY");
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 100
        }
    }

    function getColumn_time() {
        let columnClassName = "table__column-time";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Time",
            id: "time",
            accessor: "PERFORMED_TIME",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = "-";
                if (isStringTrimNotEmpty(value)) value_formatted = value;
                // if (isDateValid(value)) 
                //     value_formatted = moment(value).format("h:mm:ss a");
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 100
        }
    }

    function getColumn_location() {
        let columnClassName = "table__column-location";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Location",
            id: "location",
            accessor: "PERFORMED_LOCATION",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 200
        }
    }

    function getColumn_locationID() {
        let columnClassName = "table__column-location-id";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Location ID",
            id: "locationID",
            accessor: "PERFORMED_LOCATION_ID",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 250
        }
    }

    function getColumn_siteID() {
        let columnClassName = "table__column-site-id";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Site ID",
            id: "siteID",
            accessor: "INT_EXTEND_2",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isNotNullUndefined(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 250
        }
    }


    return [
        getColumn_category(),
        getColumn_systemRemark(),
        getColumn_userEmail(),
        getColumn_date(),
        getColumn_time(),
        getColumn_location(),
        getColumn_locationID(),
        getColumn_siteID()
    ]
}